import { PRESUPUESTADOR_UPDATE_MAXCAP } from './constants'
import { validateCapMaxFinanciacion } from './BFFUtils'

export function updateMaxCap(credit_line_id = null) {
    return (dispatch, getState) => {
        const { presupuestador } = getState()

        const { maxCap, exceedFinanceLimit } = validateCapMaxFinanciacion(
            presupuestador.lineasFinancieras,
            presupuestador.selectedLineaFinanciera || credit_line_id,
            presupuestador.cuotasAfinanciar,
            presupuestador?.nuevo?.bonification,
            presupuestador?.nuevo?.reference_price,
            presupuestador?.nuevo?.net_sale_price,
            presupuestador?.special_discount,
            presupuestador?.nuevo?.nuevo
        )
        //cuando la línea puede exceder el límite no se valida que el monto supere al maximo a financiar
        const errorAmount = exceedFinanceLimit ? false : presupuestador.montoAfinanciar > maxCap

        dispatch({
            type: PRESUPUESTADOR_UPDATE_MAXCAP,
            data: {
                maxCap,
                errorAmount
            }
        })

        return maxCap
    }
}

export function reducer(state, action) {
  if (action.type === 'PRESUPUESTADOR_UPDATE_MAXCAP') {
        return {
            ...state,
            maxCap: action.data.maxCap,
            errorAmount: action.data.errorAmount
        }
    } else {
        return state
    }
}
